import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export interface AdminTaxProfile {
  _id?: string;
  country_code: string;
  label: string;
  enabled: boolean;
  rate_bps: number;
  inclusive: boolean;
  registration_number?: string;
  effective_from: string;
  effective_to?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface AdminTaxProfileResponse {
  success?: boolean;
  message?: string;
  count?: number;
  data?: AdminTaxProfile | AdminTaxProfile[];
}

export const getAdminTaxProfiles = async (): Promise<AdminTaxProfile[]> => {
  const res = await apiClient.get<AdminTaxProfileResponse>(ENDPOINTS.ADMIN.TAX_PROFILES);
  const d = res.data?.data;
  return Array.isArray(d) ? d : [];
};

export const getAdminTaxProfile = async (id: string): Promise<AdminTaxProfile | null> => {
  const res = await apiClient.get<AdminTaxProfileResponse>(ENDPOINTS.ADMIN.TAX_PROFILE_DETAIL(id));
  const d = res.data?.data;
  return d && !Array.isArray(d) ? d : null;
};

export const createAdminTaxProfile = async (payload: Partial<AdminTaxProfile>): Promise<AdminTaxProfile | null> => {
  const res = await apiClient.post<AdminTaxProfileResponse>(ENDPOINTS.ADMIN.TAX_PROFILES, payload);
  const d = res.data?.data;
  return d && !Array.isArray(d) ? d : null;
};

export const updateAdminTaxProfile = async (id: string, payload: Partial<AdminTaxProfile>): Promise<AdminTaxProfile | null> => {
  const res = await apiClient.put<AdminTaxProfileResponse>(ENDPOINTS.ADMIN.TAX_PROFILE_DETAIL(id), payload);
  const d = res.data?.data;
  return d && !Array.isArray(d) ? d : null;
};

export const toggleAdminTaxProfile = async (id: string): Promise<AdminTaxProfile | null> => {
  const res = await apiClient.patch<AdminTaxProfileResponse>(ENDPOINTS.ADMIN.TAX_PROFILE_TOGGLE(id), {});
  const d = res.data?.data;
  return d && !Array.isArray(d) ? d : null;
};

export const deleteAdminTaxProfile = async (id: string): Promise<boolean> => {
  const res = await apiClient.delete<AdminTaxProfileResponse>(ENDPOINTS.ADMIN.TAX_PROFILE_DETAIL(id));
  return Boolean(res.data?.success);
};
